import * as Sentry from '@sentry/react';

export function initSentry(version) {
  const sentryOptions = {
    ignoreErrors: [
      // https://stackoverflow.com/questions/49384120/resizeobserver-loop-limit-exceeded
      'ResizeObserver loop limit exceeded',
    ],
    blacklistUrls: [],
    whitelistUrls: [/chownow\.com/],
  };

  const sentryUrl = import.meta.env.VITE_SENTRY_URL;

  if (sentryUrl && sentryUrl !== 'disabled') {
    Sentry.init({
      ...sentryOptions,
      dsn: sentryUrl,
      environment: import.meta.env.VITE_DEPLOY_ENV || import.meta.env.DEPLOY_ENV,
      release: version,
    });
  }
}

// Sentry Exception Logging
export function logException({ message, context, tags, error }) {
  const err = message ? new Error(message) : error;

  if (error?.name) {
    err.name = error.name;
  }

  Sentry.withScope(scope => {
    if (context) {
      Object.entries(context).forEach(([key, value]) => {
        scope.setExtra(key, value);
      });
    }

    if (tags) {
      Object.entries(tags).forEach(([key, value]) => {
        scope.setTag(key, value);
      });
    }

    Sentry.captureException(err);
  });

  // eslint-disable-next-line no-console
  if (window.console && console.error) {
    console.error(message || error); // eslint-disable-line no-console
  }
}

// Sentry Message Logging
export function logMessage(message, context, level, tags) {
  Sentry.withScope(scope => {
    Object.entries(tags ?? {}).forEach(([key, value]) => {
      scope.setTag(key, value);
    });

    Sentry.captureMessage(message, {
      extra: context,
      level, // one of 'info', 'warning', or 'error'
    });
  });

  // eslint-disable-next-line no-console
  if (window.console && console.info) {
    console.info(message, context, level); // eslint-disable-line no-console
  }
}

// Heap Custom Event Logging
/** @param {{ eventName: string, properties?: Record<string, unknown> }} options */
export function logAnalytics({ eventName, properties }) {
  window.heap?.track(eventName, properties);
}
